export const SMELL_AXES = [
  "Fruity",
  "Citrus",
  "Berry",
  "Tropical",
  "Floral",
  "Herbal",
  "Green",
  "Vegetal",
  "Spicy",
  "Woody",
  "Smoky",
  "Roast",
  "Dairy",
  "Buttery",
  "Creamy",
  "Caramel",
  "Vanilla",
  "Nutty",
  "Fatty",
  "Fermented",
];
